import { getContext, setContext } from "svelte";
import { derived } from "svelte/store";
import {
  candidateApiStore,
  candidateEducationStore,
  candidateExperienceStore,
  candidateStore,
} from "../../stores";

const isResumeLoadingStore = derived(
  [
    candidateApiStore.meta,
    candidateEducationStore.meta,
    candidateExperienceStore.meta,
  ],
  ([$candidateApiMeta, $educationMeta, $experienceMeta]) =>
    $candidateApiMeta.fetching ||
    $educationMeta.fetching ||
    $experienceMeta.fetching,
);

class ShareResumeContext {
  #candidate = $state({});

  #experience = $state([]);
  #education = $state([]);

  #loading = $state(true);

  get loading() {
    return this.#loading;
  }

  hideName = $state(false);
  hideContactInfo = $state(true);

  expiry = $state(null);

  get name() {
    return this.hideName
      ? this.#candidate.name
          .split(/\s+/)
          .map((x) => x[0])
          .join("")
      : this.#candidate.name;
  }

  get resume() {
    return {
      name: this.name,
      linkedinUrl: this.hideName ? null : this.#candidate.linkedinUrl,
      role: this.#candidate.role,
      emails: this.hideContactInfo ? [] : this.#candidate.emails,
      phones: this.hideContactInfo ? [] : this.#candidate.phones,
      education: this.#education,
      experience: this.#experience,
    };
  }

  buildPayload() {
    return {
      kind: "resume",
      name: `${this.name} - Resume`,
      expiry: this.expiry,
      candidateId: this.#candidate.candidateId,
      resume: this.resume,
    };
  }

  constructor() {
    candidateStore.subscribe((value) => {
      this.#candidate = value;
    });
    candidateEducationStore.subscribe((value) => {
      this.#education = value;
    });
    candidateExperienceStore.subscribe((value) => {
      this.#experience = value;
    });

    isResumeLoadingStore.subscribe((value) => {
      this.#loading = value;
    });

    this.expiry = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
  }
}

const SHARE_RESUME_CONTEXT = Symbol("share-resume-context");

export const createShareResumeContext = () => {
  const shareResumeContext = new ShareResumeContext();
  setContext(SHARE_RESUME_CONTEXT, shareResumeContext);
  return shareResumeContext;
};

export const getShareResumeContext = () => getContext(SHARE_RESUME_CONTEXT);
